export default __webpack_public_path__ + "static/media/account-card-details-outline.d17e4158.svg";